import * as bootstrap from 'bootstrap';
import jsKit from './jsKit';
import Cookies from 'js-cookie';
import InnerImageZoom from 'inner-image-zoom';
import LazyLoad from 'vanilla-lazyload';
import Choices from "choices.js";

const ams = (() => {
    const defaults = {
        debugMode: false,
        code: 'NONE',
        precision : 2,
        decimal: ',',
        thousand: '&nbsp;',
        format: '{{value}}'
    };
    const currencyList = {
        PLN: {
            code: 'PLN',
            thousand: '&nbsp;',
            decimal: ',',
            symbol: 'zł',
            format: '{{value}}&nbsp;{{symbol}}'
        },
        EUR: {
            code: 'EUR',
            thousand: '&nbsp;',
            decimal: '.',
            symbol: '€',
            format: '{{value}}&nbsp;{{symbol}}'
        }
    };
    const getScopedElements = (scope, selector) => {
        if (!scope || !selector) {
            return [];
        }

        const elements = [];

        if (scope instanceof Element && scope.matches(selector)) {
            elements.push(scope);
        }

        if (scope.querySelectorAll) {
            elements.push(...Array.from(scope.querySelectorAll(selector)));
        }

        return elements;
    };
    const getXmlItems = (xml) => {
        if (!xml || typeof xml.querySelectorAll !== 'function') {
            return [];
        }

        return Array.from(xml.querySelectorAll('z > t'));
    };

    return {
        getConfig: () => {
            const base = {
                kraj: 0,
                waluta: 'PLN',
                kurs: 1,
                user: '',
                stanMax: 5,
                bonus: 0,
                motoprofit: 0,
                ksv: 0,
            };

            const numericKeys = new Set(['kraj', 'kurs', 'stanMax', 'bonus', 'motoprofit', 'ksv']);

            const cfg = { ...base };

            // 1) główny config z #app-cfg
            const el = document.getElementById('app-cfg');
            if (el) {
                const data = el.dataset;
                Object.keys(base).forEach((key) => {
                    if (data[key] !== null && data[key] !== '') {
                        cfg[key] = numericKeys.has(key) ? Number(data[key]) : data[key];
                    }
                });
            }

            // 2) per-strona override'y: #app-cfg-ksv, #app-cfg-kurs, itd.
            Object.keys(base).forEach((key) => {
                const o = document.getElementById(`app-cfg-${key}`);
                if (!o) return;
                const val = o.dataset[key];
                if (val === null || val === '') return;

                cfg[key] = numericKeys.has(key) ? Number(val) : val;
            });

            return cfg;
        },
        loadPage: async (url, key) => {
            if (defaults.debugMode) {
                console.log('loadPage()');
            }

            const main = document.querySelector('#main');

            jsKit.showLoader(main);

            const postCB = (html) => {
                jsKit.hideLoader(main);
                main.innerHTML = html;
                jsKit.initDynamicContent(main);
                ams.insertHtml(main);
                ams.getProductAjax();
                ams.setPrices();
                ams.calculateAvailabilityDeferred();
            };

            await jsKit.fetchUrl(url, postCB, 'text', 'POST', {[key]: ams.textStorageXML(key)});
        },
        insertHtml: async (scope = document) => {
            if (defaults.debugMode) {
                console.log('insertHtml()');
            }

            const root = scope && scope.querySelectorAll ? scope : document;
            const elements = [];

            if (root instanceof Element && root.hasAttribute('insertHtml')) {
                elements.push(root);
            }

            elements.push(...Array.from(root.querySelectorAll('[insertHtml]')));

            await Promise.all(elements.map((element) => new Promise((resolve) => {
                const url = element.getAttribute('insertHtml');
                if (!url) {
                    resolve();
                    return;
                }

                jsKit.fetchUrl(url, (html) => {
                    element.innerHTML = html;
                    element.dataset.insertHtmlResolved = '1';
                    element.removeAttribute('insertHtml');
                    jsKit.initDynamicContent(element);
                    resolve();
                });
            })));
        },
        getProductAjax: async (xmlPayload = '') => {
            if (defaults.debugMode) {
                console.log('getProductAjax()');
            }

            let payload = typeof xmlPayload === 'string' ? xmlPayload.trim() : '';

            if (!payload) {
                const ids = Array.from(
                    document.querySelectorAll('.product[data-id], [data-product-details][data-id]')
                )
                    .map((product) => product.dataset.id)
                    .filter(Boolean);

                if (ids.length) {
                    payload = `<z>${ids.map((id) => `<t id="${id}"/>`).join('')}</z>`;
                }
            }

            const cfg = ams.getConfig();
            const tasks = [];

            if (payload) {
                if (Number(cfg.motoprofit)) {
                    tasks.push(ams.readMP(payload));
                }

                if (Number(cfg.bonus)) {
                    tasks.push(ams.readBN(payload));
                }

                tasks.push(ams.readOC(payload));
            }

            tasks.push(ams.readAvailability());

            await Promise.all(tasks);

            return payload;
        },
        getPriceDisplayMode: (cfg = ams.getConfig()) => {
            const displayMode = cfg.user ? String(ams.getLocal('rb', 0) || 0) : '0';
            let priceAttr = 'data-cena';
            let valuationAttr = 'data-brutto';
            let netto = cfg.kraj !== 0;

            if (cfg.user) {
                if (displayMode === '1') {
                    priceAttr = 'data-detal';
                    valuationAttr = 'data-detal';
                } else if (displayMode === '2') {
                    netto = true;
                    valuationAttr = 'data-netto';
                }
            }

            return {
                displayMode,
                netto,
                priceAttr,
                valuationAttr,
            };
        },
        syncPriceToggleButtons: (displayMode = '0') => {
            document.querySelectorAll('[data-js-change-rabat]').forEach((button) => {
                const mode = String(button.dataset.jsChangeRabat || button.getAttribute('rab') || '0');
                const isActive = mode === String(displayMode);

                button.classList.toggle('active', isActive);
                button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            });
        },
        changeRabat: (eOrEl) => {
            const source = eOrEl instanceof Event
                ? (eOrEl.delegateTarget || eOrEl.target)
                : eOrEl;

            const rawMode = source instanceof HTMLElement
                ? (source.dataset.jsChangeRabat || source.getAttribute('rab') || '0')
                : String(source ?? '0');
            const currentMode = String(ams.getLocal('rb', 0) || '0');
            const nextMode = String(rawMode) === currentMode ? '0' : String(rawMode);

            ams.setLocal('rb', nextMode);
            ams.setPrices();

            return nextMode;
        },
        readMP: async (xmlPayload) => {
            await new Promise((resolve) => {
                jsKit.fetchUrl('make.asp?i=37', (xml) => {
                    getXmlItems(xml).forEach((item) => {
                        const id = item.getAttribute('i');
                        const value = item.getAttribute('k');
                        const container = document.getElementById(`mprf${id}`);

                        if (!container) {
                            return;
                        }

                        const badge = document.createElement('span');
                        badge.title = 'wartość bonusu motoPROFIT';
                        badge.className = 'label label-danger';
                        badge.textContent = `motoPROFIT ${value}`;

                        container.replaceChildren(badge);
                    });

                    resolve();
                }, 'xml', 'POST', { s: xmlPayload });
            });
        },
        readBN: async (xmlPayload) => {
            await new Promise((resolve) => {
                jsKit.fetchUrl('make.asp?i=36', (xml) => {
                    getXmlItems(xml).forEach((item) => {
                        const id = item.getAttribute('i');
                        const value = item.getAttribute('k');
                        const container = document.getElementById(`bns${id}`);

                        if (!container) {
                            return;
                        }

                        const badge = document.createElement('span');
                        badge.title = 'wartość Twojego bonusu';
                        badge.className = 'label label-warning';
                        badge.textContent = `Bonus ${value} zł`;

                        container.replaceChildren(badge);
                    });

                    resolve();
                }, 'xml', 'POST', { s: xmlPayload });
            });
        },
        readOC: async (xmlPayload) => {
            await new Promise((resolve) => {
                jsKit.fetchUrl('make.asp?i=95', (xml) => {
                    getXmlItems(xml).forEach((item) => {
                        const id = item.getAttribute('i');
                        const rating = Number(item.getAttribute('o') || 0);
                        const votes = Number(item.getAttribute('g') || 0);
                        const container = document.getElementById(`oc${id}`);

                        if (!container) {
                            return;
                        }

                        const link = document.createElement('a');
                        let title = 'oceń produkt';

                        link.className = 'btn-link';
                        link.href = '#';
                        link.addEventListener('click', (event) => {
                            event.preventDefault();

                            if (typeof window.ocenProdukt === 'function') {
                                window.ocenProdukt(id);
                            }
                        });

                        for (let index = 1; index < 6; index += 1) {
                            const icon = document.createElement('i');

                            if (rating >= index) {
                                icon.className = 'fa fa-star mr';
                            } else if (Math.ceil(rating) === index) {
                                icon.className = 'fa fa-star-half-o mr';
                            } else {
                                icon.className = 'fa fa-star-o mr';
                            }

                            link.appendChild(icon);
                        }

                        if (votes > 0) {
                            const badge = document.createElement('span');
                            badge.className = 'badge ocbadge';
                            badge.textContent = String(Math.round(rating * 10) / 10);
                            link.appendChild(badge);
                            title += `, oddanych głosów: ${votes}`;
                        }

                        link.title = title;
                        container.replaceChildren(link);
                    });

                    resolve();
                }, 'xml', 'POST', { s: xmlPayload });
            });
        },
        readAvailability: async () => {
            const cfg = ams.getConfig();
            const stanMax = Number(cfg.stanMax) || 5;

            const updateLegacyProductTotal = (id, amount) => {
                const product = document.getElementById(`pr${id}`);
                if (!product) {
                    return;
                }

                const currentState = product.getAttribute('data-stan') || '';
                if (currentState && currentState.charAt(1) === '0') {
                    product.setAttribute('data-stan', `${currentState.charAt(0)}1`);
                }

                const totalMeter = document.getElementById(`sd${id}`);
                if (!totalMeter) {
                    return;
                }

                const currentTotal = Number(totalMeter.getAttribute('value') || 0);
                const nextTotal = currentTotal + amount;

                totalMeter.setAttribute('value', String(nextTotal));

                const label = totalMeter.previousElementSibling;
                if (label) {
                    label.innerHTML = nextTotal > stanMax ? `>${stanMax}` : String(Number(nextTotal));
                }
            };

            document.querySelectorAll('.sv').forEach((element) => {
                const value = Number(element.getAttribute('value') || 0);

                if (value > 0) {
                    const label = element.previousElementSibling;
                    if (label) {
                        label.innerHTML = value > stanMax ? `>${stanMax}` : String(value);
                    }

                    const id = element.getAttribute('data-id');
                    if (id) {
                        updateLegacyProductTotal(id, value);
                    }
                }

                element.classList.remove('sv');
            });

            const remoteSources = Array.from(document.querySelectorAll('.mzd[data-value]'));

            await Promise.all(remoteSources.map((element) => new Promise((resolve) => {
                const value = element.getAttribute('data-value');
                if (!value) {
                    element.remove();
                    resolve();
                    return;
                }

                jsKit.fetchUrl('stan/stan.asp', (xml) => {
                    const responseRoot = typeof xml?.querySelector === 'function' ? xml.querySelector('z') : null;
                    const prefix = responseRoot ? responseRoot.getAttribute('r') : '';

                    getXmlItems(xml).forEach((item) => {
                        const id = item.getAttribute('i');
                        const multiplier = Number(item.getAttribute('m') || 1);
                        const rawValue = Number(item.getAttribute('k') || 0) * multiplier;
                        const displayValue = rawValue > stanMax ? `>${stanMax}` : String(rawValue);
                        const normalizedValue = rawValue > stanMax ? stanMax + 1 : rawValue;

                        if (prefix) {
                            const meter = document.getElementById(`${prefix}-${id}`);
                            if (meter) {
                                meter.setAttribute('value', String(normalizedValue));
                                meter.value = normalizedValue;

                                const label = meter.previousElementSibling;
                                if (label) {
                                    label.textContent = displayValue;
                                }
                            }

                            document.querySelectorAll('[data-availability-item]').forEach((availabilityItem) => {
                                if (
                                    availabilityItem.getAttribute('data-magazyn-parametr') !== prefix ||
                                    availabilityItem.getAttribute('data-magazyn-id') !== id
                                ) {
                                    return;
                                }

                                availabilityItem.setAttribute('data-magazyn-stan', String(normalizedValue));
                                availabilityItem.dataset.magazynStan = String(normalizedValue);
                                availabilityItem.setAttribute('data-magazyn-loaded', '1');
                                availabilityItem.dataset.magazynLoaded = '1';

                                const debugEl = availabilityItem.querySelector('.availability-debug');
                                if (debugEl) {
                                    debugEl.setAttribute('data-magazyn-stan', String(normalizedValue));
                                }
                            });
                        }

                        updateLegacyProductTotal(id, normalizedValue);
                    });

                    element.remove();
                    resolve();
                }, 'xml', 'POST', { s: value });
            })));

            ams.calculateAvailabilityDeferred();
        },
        // START user
        userLogin: async () => {
            if (defaults.debugMode) {
                console.log('userLogin()');
            }

            const loginInput = document.querySelector('#login');
            const passwordInput = document.querySelector('#password');
            const rememberMe = document.querySelector('#rememberme');
            const responseBox = document.querySelector('#loginResponse');

            if (!loginInput || !passwordInput || !responseBox) return;

            const login = loginInput.value || '';
            const password = passwordInput.value || '';

            const postCB = async (data) => {
                const ret = (data || '').trim();

                if (ret.length > 0) {
                    responseBox.innerHTML = '';
                    if (rememberMe && rememberMe.checked) {
                        await jsKit.fetchUrl('make.asp?i=24a', () => {
                            location.reload();
                        });
                    } else {
                        location.reload();
                    }
                } else {
                    responseBox.innerHTML = `<div class="alert alert-danger alert-dismissible rounded-4" role="alert">
                            <i class="icon-alert fs-24 me-8"></i>
                            błędny login lub hasło  
                            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                        </div>`;
                }
            }

            await jsKit.fetchUrl('make.asp?i=24', postCB,'text','POST', { login, password })
        },
        userLogout: async () => {
            if (defaults.debugMode) {
                console.log('userLogout()');
            }
            await jsKit.fetchUrl('make.asp?i=24b', () => {
                location.reload();
            });
        },
        // KONIEC user

        // START główna wyszukiwarka, panel z podpowiedziami
        showSearchResult: async (e) => {
            if (jsKit.isMobile() || jsKit.rwdMedia.xs() || jsKit.rwdMedia.sm() || jsKit.rwdMedia.md()) {
                return;
            }

            if (defaults.debugMode) {
                console.log('showSearchResult()');
            }

            let selectedIndex = -1;

            if (!e.target.data) {
                e.target.data = {
                    searchSpinner: document.querySelector('#search-input-spinner'),
                    resultsContainer: document.querySelector('#panel_search_hints'),
                    keydownEvent: false,
                    setupAutocomplete: async () => {
                        const input = e.target;
                        const container = input.data.resultsContainer;

                        // aktualny indeks zaznaczonego elementu
                        let localSelectedIndex = -1;

                        // wspólna funkcja: podświetlanie + scroll
                        const updateSelection = () => {
                            const itemsList = container.querySelectorAll('.autocomplete-item');
                            const itemsLength = itemsList.length;

                            if (!itemsLength) {
                                return;
                            }

                            // korekta indeksu w razie czego
                            if (localSelectedIndex < 0) localSelectedIndex = 0;
                            if (localSelectedIndex >= itemsLength) localSelectedIndex = itemsLength - 1;

                            input.dataset.selectedIndex = localSelectedIndex;

                            itemsList.forEach((item, index) => {
                                const link = item.querySelector('.autocomplete-item-link');
                                if (!link) return;

                                if (index === localSelectedIndex) {
                                    link.classList.add('bg-body', 'shadow-lg');
                                } else {
                                    link.classList.remove('bg-body', 'shadow-lg');
                                }
                            });

                            // scroll – żeby zaznaczony był zawsze widoczny
                            const selectedItem = itemsList[localSelectedIndex];
                            if (!selectedItem) return;

                            const margin = 8; // Twój margines
                            const itemRect = selectedItem.getBoundingClientRect();
                            const containerRect = container.getBoundingClientRect();

                            const topLimit = containerRect.top + margin;
                            const bottomLimit = containerRect.bottom - margin;

                            if (itemRect.top < topLimit) {
                                const diff = topLimit - itemRect.top;
                                container.scrollTop -= diff;
                            } else if (itemRect.bottom > bottomLimit) {
                                const diff = itemRect.bottom - bottomLimit;
                                container.scrollTop += diff;
                            }
                        };

                        // 🔹 NAWIGACJA KLAWIATURĄ
                        input.addEventListener('keydown', (ev) => {
                            input.data.keydownEvent = true;

                            const itemsList = container.querySelectorAll('.autocomplete-item');
                            const itemsLength = itemsList.length;

                            if (!itemsLength) {
                                return;
                            }

                            if (ev.key === 'ArrowDown') {
                                ev.preventDefault();
                                localSelectedIndex = (localSelectedIndex + 1 + itemsLength) % itemsLength;
                                updateSelection();
                            } else if (ev.key === 'ArrowUp') {
                                ev.preventDefault();
                                localSelectedIndex = (localSelectedIndex - 1 + itemsLength) % itemsLength;
                                updateSelection();
                            } else if (ev.key === 'Enter' && localSelectedIndex !== -1) {
                                const selectedItem = itemsList[localSelectedIndex];
                                window.location.href = selectedItem.dataset.link;
                            } else if (ev.key === 'Escape') {
                                input.blur();
                            }
                        });

                        // 🔹 AKTYWACJA PO NAJECHANIU MYSZĄ
                        container.addEventListener('mouseover', (ev) => {
                            const item = ev.target.closest('.autocomplete-item');
                            if (!item || !container.contains(item)) return;

                            const itemsList = container.querySelectorAll('.autocomplete-item');
                            const itemsArray = Array.from(itemsList);
                            const index = itemsArray.indexOf(item);

                            if (index === -1) return;

                            localSelectedIndex = index;
                            updateSelection();
                        });
                    }
                }
            }

            const searchPhrase = e.target.value.trim();
            e.target.focus();
            const isSearchEnabled = searchPhrase.length > 3;

            if (isSearchEnabled) {
                e.target.data.searchSpinner.classList.remove('d-none');
                const url = `make.asp?i=19&numer=${encodeURIComponent(e.target.value)}`;

                const showResult = (html) => {
                    if (html) {
                        e.target.classList.add('is-enabled');
                        setTimeout(() => e.target.data.searchSpinner.classList.add('d-none'), 1000);
                        e.target.data.resultsContainer.innerHTML = html;
                        if (e.target.data.keydownEvent === false) {
                            e.target.data.setupAutocomplete();
                        }
                    }
                };

                await jsKit.fetchUrl(url, showResult);
            } else {
                e.target.classList.remove('is-enabled');
            }

        },
        filterResult: (e) => {
            const {target} = e;
            const val = (target.value || '').trim().toUpperCase();
            const links = document.querySelector(target.dataset.jsFilterResult);

            links.querySelectorAll('.autocomplete-item-link').forEach(link => {
                const nazwa = (link.dataset.nazwa || '').toUpperCase();
                const li = link.closest('.autocomplete-item') || link;
                const match = !val || nazwa.includes(val);
                li.classList.toggle('d-none', !match);
            })
        },
        submitSearchForm: (e) => {
            if (defaults.debugMode) {
                console.log('submitSearchForm()');
            }

            const input = document.getElementById('search-products-phrase');
            if (!input) return false;

            const value = (input.value || '').trim();
            if (!value) return false;

            window.location.href = `make.asp?t=16&amp;h=1&amp;numer=` + encodeURIComponent(value);
            return false;
        },
        // Zwraca obiekt ostatnio zapisanego auta z historii (lub null)
        isCarHistory: () => {
            if (defaults.debugMode) {
                console.log('isCarHistory()');
            }

            // pobranie XML-a historii pojazdów (bezpiecznie przez helper)
            const xmlRaw = ams.textStorageXML('hw'); // domyślnie "<z/>"
            if (!xmlRaw) return null;

            let xmlDoc;
            try {
                xmlDoc = new DOMParser().parseFromString(xmlRaw, 'text/xml');
            } catch (e) {
                return null;
            }

            const root = xmlDoc.documentElement;
            if (!root) return null;

            // pierwszy <t> = ostatnio zapisane auto
            const lastCar = root.querySelector('t');
            if (!lastCar) return null;

            // mapowanie znanych atrybutów na prosty obiekt
            const MarkaId = lastCar.getAttribute('MarkaId') || '';
            const ModelId = lastCar.getAttribute('ModelId') || '';
            const WersjaId = lastCar.getAttribute('WersjaId') || '';

            // dodatkowe atrybuty (jeśli kiedyś dojdą nowe)
            const extra = {};
            if (lastCar.attributes && lastCar.attributes.length) {
                for (let i = 0; i < lastCar.attributes.length; i++) {
                    const a = lastCar.attributes[i];
                    if (!a || !a.name) continue;
                    if (['MarkaId', 'ModelId', 'WersjaId'].includes(a.name)) continue;
                    extra[a.name] = a.value;
                }
            }

            return {
                MarkaId,
                ModelId,
                WersjaId,
                ...(Object.keys(extra).length ? { extra } : {}),
            };
        },

        // Zostawiamy kompatybilność: jeśli gdzieś jest używane tylko ID
        hasCarIdHistory: () => {
            const car = ams.isCarHistory();
            return car ? (car.id || null) : null;
        },
        // KONIEC główna wyszukiwarka, panel z podpowiedziami

        // START obsługa wyszukiwarki aut
        markiScopeSwitch: async (e) => {
            if (defaults.debugMode) {
                console.log('markiScopeSwitch()');
            }
            const {target} = e;
            const url = target.dataset.jsMarkiScopeSwitch;
            const scope = target.checked ? target.dataset.jsCheckedValue : target.dataset.jsUncheckedValue;

            const parent = target.closest('[data-js-car-search]');

            const getCB = (html) => {
                parent.innerHTML = html;
                ams.initMarkiChoices();
            };
            await jsKit.fetchUrl(url + scope, (html) => getCB(html));
        },
        initMarkiChoices: () => {
            if (defaults.debugMode) {
                console.log('initMarkiChoices()');
            }

            const carHistory = ams.isCarHistory();

            const select = document.querySelector('[data-js-init-marki-select]');

            // zaznaczanie ostatnio wybranej marki
            if (carHistory && carHistory.MarkaId && select) {
                const option = select.querySelector(
                    `option[data-nazwa-id="${CSS.escape(carHistory.MarkaId)}"]`
                );

                if (option) {
                    option.selected = true;
                }
            }
            const parent = document.querySelector('[data-js-car-search]');

            if (!select) return;


            if (select.dataset.choicesInit) return;

            const markiChoices = new Choices(select, {
                searchEnabled: true,
                placeholderValue: 'Wybierz markę...',
                searchPlaceholderValue: 'Szukaj marki...',
                shouldSort: false,
                callbackOnCreateTemplates: function (strToEl, escapeForTemplate, getClassNames) {
                    // helper do ogarnięcia customProperties
                    const getCustomProps = (data) => {
                        let cp = data.customProperties;
                        if (!cp) return {};
                        if (typeof cp === 'string') {
                            try {
                                cp = JSON.parse(cp);
                            } catch (e) {
                                cp = {};
                            }
                        }
                        return cp;
                    };

                    return {
                        // element na liście rozwijanej
                        choice: ({classNames}, data) => {
                            const customProps = getCustomProps(data);
                            const logo = customProps.logo;
                            const label = customProps.nazwa || data.label || '';
                            return strToEl(`<div class="d-flex align-items-center ${getClassNames(classNames.item).join(' ')} ${getClassNames(classNames.itemChoice).join(' ')} ${getClassNames(data.disabled ? classNames.itemDisabled : classNames.itemSelectable).join(' ')}"
    data-id="${data.id}"
    data-value="${escapeForTemplate(data.value)}"
    data-choice
    ${data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable'}
    role="option">
    ${logo ? `<div class="my-n8 me-8"><img src="${logo}" alt="${label}" class="me-2" style="height:40px;"></div>` : ''}
    <span>${label}</span>
</div>`);
                        },

                        // element w polu wybranej opcji
                        item: ({classNames}, data) => {
                            const customProps = getCustomProps(data);
                            const logo = customProps.logo;
                            const label = customProps.nazwa || data.label || '';
                            return strToEl(`<div class="d-flex align-items-center ${getClassNames(classNames.item).join(' ')} ${getClassNames(data.highlighted ? classNames.highlightedState : classNames.itemSelectable).join(' ')} ${data.placeholder ? classNames.placeholder : ''}"
   data-item
   data-id="${data.id}"
   data-value="${escapeForTemplate(data.value)}"
   ${data.active ? 'aria-selected="true"' : ''}
   ${data.disabled ? 'aria-disabled="true"' : ''}>
    ${logo ? `<div class="my-n8 me-8"><img src="${logo}" alt="${label}" class="me-2" style="height:40px;"></div>` : ''}
    <span>${label}</span>
</div>`);
                        },
                    };
                },
            });
            select.choicesInstance = markiChoices;

            // flaga – zabezpiecza przed ponowną inicjalizacją tego samego selecta
            select.dataset.choicesInit = '1';

            // budowa opcji z <option>ów
            const options = Array.from(select.options)
                .map((opt) => ({
                    value: opt.value,
                    label: opt.text,
                    selected: opt.selected,
                    disabled: opt.disabled,
                    placeholder: opt.value === '',
                    customProperties: {
                        logo: opt.dataset.logo || null,
                        nazwa: opt.dataset.nazwa || opt.text,
                        typ: opt.dataset.typ,
                        zakres: opt.dataset.zakres,
                    },
                }));

            markiChoices.clearChoices();
            markiChoices.setChoices(options, 'value', 'label', true);

            // jeżeli marka pochodzi z historii – automatycznie wywołaj logikę jak po zmianie
            if (carHistory && carHistory.MarkaId) {
                // mikro-delay, żeby Choices zdążył ustawić stan
                requestAnimationFrame(() => {
                    markaSelected(carHistory);
                });
            }

            const markaSelected = (carHistory) => {
                const selected = markiChoices.getValue();
                const current = Array.isArray(selected) ? selected[0] : selected;
                if (!current || !current.value) return;

                const idPr = current.value;
                const {zakres} = current.customProperties || {};
                if (!zakres) return;

                const url = `make.asp?i=51&q=o${idPr}&zakres=${zakres}`;

                jsKit.fetchUrl(url, (html) => {
                    const container = document.querySelector('#modele-lista');
                    if (container) {
                        container.innerHTML = html;
                        ams.initModeleChoices(parent, carHistory);
                    }
                });
            }

            // obsługa zmiany marki
            markiChoices.passedElement.element.addEventListener('change', () => markaSelected(null));

        },
        initModeleChoices: (parent, carHistory = null) => {
            if (defaults.debugMode) {
                console.log('initModeleChoices()');
            }

            const select = parent.querySelector(`[data-js-init-modele-select]`);

            // zaznaczanie ostatnio wybranego modalu
            if (carHistory && carHistory.ModelId && select) {
                const option = select.querySelector(
                    `option[data-nazwa-id="${CSS.escape(carHistory.ModelId)}"]`
                );

                if (option) {
                    option.selected = true;
                }
            }

            if (!select) return;
            if (select.dataset.choicesInit) return;

            const modeleChoices = new Choices(select, {
                searchEnabled: true,
                placeholderValue: 'Wybierz model...',
                searchPlaceholderValue: 'Szukaj modelu...',
                shouldSort: false,
                callbackOnCreateTemplates: function (strToEl, escapeForTemplate, getClassNames) {
                    const getCustomProps = (data) => {
                        let cp = data.customProperties;
                        if (!cp) return {};
                        if (typeof cp === 'string') {
                            try {
                                cp = JSON.parse(cp);
                            } catch (e) {
                                cp = {};
                            }
                        }
                        return cp;
                    };

                    return {
                        // element na liście rozwijanej
                        choice: ({classNames}, data) => {
                            const customProps = getCustomProps(data);
                            const main = customProps.nazwaMain || data.label || '';
                            const extra = customProps.nazwaExtra || '';

                            return strToEl(`
<div class="text-nowrap text-truncate ${getClassNames(classNames.item).join(' ')} ${getClassNames(classNames.itemChoice).join(' ')} ${getClassNames(data.disabled ? classNames.itemDisabled : classNames.itemSelectable).join(' ')}"
     data-id="${data.id}"
     data-amount="${extra}"
     data-value="${escapeForTemplate(data.value)}"
     data-choice
     ${data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable'}
     role="option">
  ${main}
</div>`);
                        },

                        // element w polu wybranej opcji
                        item: ({classNames}, data) => {
                            const customProps = getCustomProps(data);
                            const main = customProps.nazwaMain || data.label || '';
                            const extra = customProps.nazwaExtra || '';

                            return strToEl(`
<div class="text-nowrap text-truncate ${getClassNames(classNames.item).join(' ')} ${getClassNames(data.highlighted ? classNames.highlightedState : classNames.itemSelectable).join(' ')} ${data.placeholder ? classNames.placeholder : ''}"
     data-item
     data-id="${data.id}"
     data-amount="${extra}"
     data-value="${escapeForTemplate(data.value)}"
     ${data.active ? 'aria-selected="true"' : ''}
     ${data.disabled ? 'aria-disabled="true"' : ''}>
  ${main}
</div>`);
                        },
                    };
                },
            });
            select.choicesInstance = modeleChoices;
            // flaga – zabezpiecza przed ponowną inicjalizacją tego samego selecta
            select.dataset.choicesInit = '1';

            // budowa opcji z <option>ów
            const options = Array.from(select.options)
                .map((opt) => ({
                    value: opt.value,
                    label: opt.text,
                    selected: opt.selected,
                    disabled: opt.disabled,
                    placeholder: opt.value === '',
                    customProperties: {
                        nazwaMain: opt.dataset.nazwaMain || opt.text,
                        nazwaExtra: opt.dataset.nazwaExtra || '',
                    },
                }));

            modeleChoices.clearChoices();
            modeleChoices.setChoices(options, 'value', 'label', true);
            ams.handleMarkiControlsState(2, parent);

            // jeżeli model pochodzi z historii – automatycznie wywołaj logikę jak po zmianie
            if (carHistory && carHistory.ModelId) {
                // mikro-delay, żeby Choices zdążył ustawić stan
                requestAnimationFrame(() => {
                    modalSelected(carHistory);
                });
            }

            const modalSelected = (carHistory) => {
                const selected = modeleChoices.getValue();
                const current = Array.isArray(selected) ? selected[0] : selected;
                if (!current) return;

                const IdMo = current.value;

                const url = `make.asp?i=53&q=o${IdMo}`;

                jsKit.fetchUrl(url, (html) => {
                    const container = document.querySelector('#silniki-lista');
                    if (container) {
                        container.innerHTML = html;
                        ams.initWersjeChoices(parent, carHistory);
                    }
                });
            }

            // obsługa zmiany modelu
            modeleChoices.passedElement.element.addEventListener('change', () => modalSelected(null));

        },
        initWersjeChoices: (parent, carHistory = null) => {
            if (defaults.debugMode) {
                console.log('initWersjeChoices()');
            }

            const select = parent.querySelector(`[data-js-init-wersje-select]`);

            console.log('carHistory', carHistory)

            // zaznaczanie ostatnio wybranej wersji
            if (carHistory && carHistory.WersjaId && select) {
                const option = select.querySelector(
                    `option[data-nazwa-id="${CSS.escape(carHistory.WersjaId)}"]`
                );

                if (option) {
                    option.selected = true;
                }
            }

            const btnSearch = parent.querySelector('[data-car-search-btn]');
            if (!select) return;
            if (select.dataset.choicesInit) return;

            const wersjeChoices = new Choices(select, {
                searchEnabled: true,
                placeholderValue: 'Wybierz wersję...',
                searchPlaceholderValue: 'Szukaj wersji...',
                shouldSort: false,
                callbackOnCreateTemplates: function (strToEl, escapeForTemplate, getClassNames) {
                    const getCustomProps = (data) => {
                        let cp = data.customProperties;
                        if (!cp) return {};
                        if (typeof cp === 'string') {
                            try {
                                cp = JSON.parse(cp);
                            } catch (e) {
                                cp = {};
                            }
                        }
                        return cp;
                    };

                    return {
                        // element na liście rozwijanej
                        choice: ({classNames}, data) => {
                            const customProps = getCustomProps(data);
                            const main = customProps.nazwaMain || data.label || '';
                            const dateScope = customProps.nazwaDateScope || '';
                            const engine = customProps.nazwaEngine || '';
                            const fuel = customProps.nazwaFuel || '';
                            const extra = customProps.nazwaExtra || '';

                            return strToEl(`
<div class="d-flex flex-column ${getClassNames(classNames.item).join(' ')} ${getClassNames(classNames.itemChoice).join(' ')} ${getClassNames(data.disabled ? classNames.itemDisabled : classNames.itemSelectable).join(' ')}"
     data-id="${data.id}"
     data-value="${escapeForTemplate(data.value)}"
     data-choice
     ${data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable'}
     role="option">
    <div class="text-nowrap text-truncate d-flex align-items-center">${fuel ? `<span class="me-8 lh-1">
    ${fuel.toUpperCase().includes("BENZYN") ? `<small class="badge text-bg-dark">PB</small>` : ''}
    ${fuel.toUpperCase().includes("LPG") ? `<small class="badge text-bg-warning">LPG</small>` : ''}
    ${fuel.toUpperCase().includes("DIESEL") || fuel === 'olej napędowy' ? `<small class="badge text-bg-success text-white">D</small>` : ''}
    ${fuel.toUpperCase().includes("ELEKTR") ? `<small class="badge text-bg-info text-white">E</small>` : ''}
</span>` : ''} ${main} ${dateScope ? `<small class="ms-8 text-body text-opacity-50">${dateScope}</small>` : ''}</div>
    ${engine ? `<div class="text-body">${engine}</div>` : ''} 
    ${extra ? `<small class="text-body text-opacity-50">${extra}</small>` : ''}
</div>`);
                        },

                        // element w polu wybranej opcji
                        item: ({classNames}, data) => {
                            const customProps = getCustomProps(data);
                            const main = customProps.nazwaMain || data.label || '';
                            const dateScope = customProps.nazwaDateScope || '';
                            const engine = customProps.nazwaEngine || '';
                            const fuel = customProps.nazwaFuel || '';
                            const extra = customProps.nazwaExtra || '';

                            return strToEl(`
<div class="d-flex flex-column ${getClassNames(classNames.item).join(' ')} ${getClassNames(data.highlighted ? classNames.highlightedState : classNames.itemSelectable).join(' ')} ${data.placeholder ? classNames.placeholder : ''}"
     data-item
     data-id="${data.id}"
     data-value="${escapeForTemplate(data.value)}"
     ${data.active ? 'aria-selected="true"' : ''}
     ${data.disabled ? 'aria-disabled="true"' : ''}>
    <div class="text-nowrap text-truncate d-flex align-items-center">${fuel ? `<span class="me-8 lh-1">
    ${fuel.toUpperCase().includes("BENZYN") ? `<small class="badge text-bg-dark">PB</small>` : ''}
    ${fuel.toUpperCase().includes("LPG") ? `<small class="badge text-bg-warning">LPG</small>` : ''}
    ${fuel.toUpperCase().includes("DIESEL") || fuel === 'olej napędowy' ? `<small class="badge text-bg-success text-white">D</small>` : ''}
    ${fuel.toUpperCase().includes("ELEKTR") ? `<small class="badge text-bg-info text-white">E</small>` : ''}
</span>` : ''} ${main}</div>
    ${engine ? `<small class="text-nowrap text-truncate text-body text-opacity-50 fs-12">${engine}</small>` : ''}
</div>`);
                        },
                    };
                },
            });
            select.choicesInstance = wersjeChoices;

            // flaga – zabezpiecza przed ponowną inicjalizacją tego samego selecta
            select.dataset.choicesInit = '1';

            // budowa opcji z &lt;option&gt;ów
            const options = Array.from(select.options)
                .map((opt) => ({
                    value: opt.value,
                    label: opt.text,
                    selected: opt.selected,
                    disabled: opt.disabled,
                    placeholder: opt.value === '',
                    customProperties: {
                        nazwaMain: opt.dataset.nazwaMain || opt.text,
                        nazwaDateScope: opt.dataset.nazwaDateScope || '',
                        nazwaEngine: opt.dataset.nazwaEngine || '',
                        nazwaFuel: opt.dataset.nazwaFuel || '',
                        nazwaExtra: opt.dataset.nazwaExtra || '',
                    },
                }));

            wersjeChoices.clearChoices();
            wersjeChoices.setChoices(options, 'value', 'label', true);
            ams.handleMarkiControlsState(3, parent);

            // jeżeli wersja pochodzi z historii – automatycznie wywołaj logikę jak po zmianie
            if (carHistory && carHistory.WersjaId) {
                // mikro-delay, żeby Choices zdążył ustawić stan
                requestAnimationFrame(() => wersjaSelected());
            }

            const wersjaSelected = () => {
                const selected = wersjeChoices.getValue();
                const current = Array.isArray(selected) ? selected[0] : selected;
                if (!current || !current.value) return;
                btnSearch.dataset.jsOpenCarSearchModal = current.value;
                ams.handleMarkiControlsState(4, parent);

                const match = current.value.match(/q=o(\d+)/);
                const vehicleId = match ? match[1] : null;
                enableCarCatalogueBtns(vehicleId);
            }

            const enableCarCatalogueBtns = (weID) => {
                const btns = document.querySelectorAll('[data-car-catalogue-btn]');
                if (!btns.length) return;

                btns.forEach(btn => {
                    btn.disabled = false;
                    if (btn.closest('[data-bs-toggle]')) {
                        const tooltip = bootstrap.Tooltip.getOrCreateInstance(btn.closest('[data-bs-toggle]'));
                        tooltip.disable();
                    }
                    btn.dataset.carCatalogueBtn = weID;
                })
            }

            // obsługa zmiany wersji – przekierowanie na URL z value
            wersjeChoices.passedElement.element.addEventListener('change', wersjaSelected);
        },
        handleMarkiControlsState: (state, parent) => {
            if (defaults.debugMode) {
                console.log('handleMarkiControlsState()');
            }
            const selectWersja = parent.querySelector('[data-js-init-wersje-select]');
            const btnSearch = parent.querySelector('[data-car-search-btn]');

            switch (state) {
                case 2: {
                    if (selectWersja) {
                        selectWersja.disabled = true;
                        selectWersja.choicesInstance.setChoiceByValue('');
                        selectWersja.choicesInstance.disable();
                    }
                    btnSearch.classList.add('disabled');
                    break;
                }
                case 3: {
                    btnSearch.classList.add('disabled');
                    break;
                }
                case 4: {
                    btnSearch.classList.remove('disabled');
                    break;
                }
            }
        },
        openMarkiModal: async (e) => {
            if (defaults.debugMode) {
                console.log('openMarkiModal()');
            }

            const {target} = e;
            const isBtn = target.classList.contains('btn');
            if (isBtn) {
                target.classList.add('loading');
            }

            const url = target.dataset.jsOpenMarkiModal;
            if (!url) return;

            const getCB = (html) => {
                jsKit.openModal(html, {shownCB: ams.initMarkiChoices});
                if (isBtn) {
                    target.classList.remove('loading');
                }
            };
            await jsKit.fetchUrl(url, (html) => getCB(html));
        },
        openCarSearchModal: async (e) => {
            if (defaults.debugMode) {
                console.log('openCarSearchModal()');
            }

            const {target} = e;
            jsKit.showLoader(e);

            const url = target.dataset.jsOpenCarSearchModal;
            if (!url) return;

            const getCB = (html) => {
                jsKit.openModal(html, {shownCB: async () => {
                    ams.insertStorageXMLFromElement(document.querySelector("#mAll [data-js-insert-storage-xml]"));
                    const modal = document.querySelector('#mAll');

                    if (!modal) return;
                    const searchInputWrapper = modal.querySelector('[data-filter-search-wraper]');
                    searchInputWrapper.classList.add('loading');

                    const collapses = Array.from(modal.querySelectorAll('[data-js-load-collapse]'));
                    for (const collapse of collapses) {
                        // eslint-disable-next-line no-await-in-loop
                        await ams.loadCollapse(collapse, false);
                    }

                    const searchInput = searchInputWrapper.querySelector('[data-js-filter-search]');
                    if (searchInput) {
                        searchInputWrapper.classList.remove('loading');
                        searchInput.removeAttribute('disabled');
                    }
                }});
                jsKit.hideLoader(e);
            };
            await jsKit.fetchUrl(url, (html) => getCB(html));
        },
        categoryModalData: async (e) => {
            if (defaults.debugMode) {
                console.log('categoryModalData()');
            }

            const { target } = e;
            jsKit.showLoader(e);

            const url = target.dataset.jsCategoryModalData;
            if (!url) return;

            const getCB = (html) => {
                  jsKit.openModal(html, {shownCB: async () => {
                        const modal = document.querySelector('#mAll');
                        if (!modal) return;

                        const collapse = modal.querySelector('[data-js-load-collapse]');
                        await ams.loadCollapse(collapse);
                    }});
                jsKit.hideLoader(e);
            };
            await jsKit.fetchUrl(url, (html) => getCB(html));
        },
        sendQuestion: async (e) => {
            if (defaults.debugMode) {
                console.log('dataNext()');
            }

            const { target } = e;
            const [url, formaId, containerId] = target.dataset.jsSendQuestion.split(', ');
            const form = document.querySelector(`#${formaId}`);
            // Bootstrap validation
            if (!form.checkValidity()) {
                form.classList.add('was-validated');
                return;
            }

            jsKit.showLoader(e);

            const formData = new URLSearchParams(new FormData(form)).toString();
            const postCB = (html) => {
                form.classList.add('d-none');
                document.querySelector(`#${containerId}`).innerHTML = html;
                jsKit.hideLoader(e);
            };

            await jsKit.fetchUrl(url, html => postCB(html), 'text', 'POST', formData );

        },
        // KONIEC obsługa wyszukiwarki aut

        // START ceny
        money: (value, iso = 'PLN') => {
            iso = iso || '';

            var currency = currencyList[iso] || {},
                number = parseFloat(String(value).replace(',', '.')) || 0,
                places = currency.precision || defaults.precision,
                symbol = currency.symbol || iso || defaults.symbol,
                format = currency.format || defaults.format,
                decimal = currency.decimal || defaults.decimal,
                thousand = currency.thousand || defaults.thousand,
                negative = number < 0 ? '-' : '',
                i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
                j = (j = i.length) > 3 ? j % 3 : 0;
            value = negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
            return format.replace('{{symbol}}', symbol).replace('{{value}}', value);
        },
        setPrices: () => {
            const cfg = ams.getConfig();
            const kurs = Number(cfg.kurs) || 1;
            const waluta = cfg.waluta || 'PLN';
            const {
                displayMode,
                netto,
                priceAttr,
                valuationAttr,
            } = ams.getPriceDisplayMode(cfg);

            document.querySelectorAll('[data-set-price]').forEach((el) => {
                const raw = el.getAttribute(priceAttr) ?? el.getAttribute('data-cena');
                if (raw == null) return;

                let c = Number(raw) / kurs;

                if (!netto) {
                    const mRaw = el.getAttribute('data-mnoznik');
                    const m = mRaw == null ? 1 : Number(mRaw);
                    if (Number.isFinite(m)) c = m * c;
                }

                el.innerHTML = ams.money(c, waluta);
            });

            document.querySelectorAll('[data-set-valuation-label]').forEach((el) => {
                el.textContent = valuationAttr.substring(5);
            });

            document.querySelectorAll('[data-set-valuation]').forEach((el) => {
                const raw = el.getAttribute(valuationAttr) ?? el.getAttribute('data-brutto');
                if (raw == null) return;

                const c = Number(raw) / kurs;
                el.innerHTML = ams.money(c, waluta);
            });

            document.querySelectorAll('[data-set-confirm]').forEach((el) => {
                const raw = el.getAttribute('data-cena');
                if (raw == null) return;

                const c = Number(raw) / kurs;
                el.innerHTML = ams.money(c, waluta);
            });

            // 4) Liczby walutowe ogólne (dawniej: .wal + data-liczba)
            document.querySelectorAll('[data-set-value]').forEach((el) => {
                const raw = el.getAttribute('data-liczba');
                if (raw == null) return;

                let c = Number(raw) / kurs;
                let m = 1.0;

                if (cfg.kraj === 0) {
                    const mRaw = el.getAttribute('data-mnoznik');
                    const mm = mRaw == null ? 1 : Number(mRaw);
                    if (Number.isFinite(mm)) m = mm;
                }

                c = m * c;
                el.innerHTML = ams.money(c, waluta);
            });

            ams.syncPriceToggleButtons(displayMode);
        },
        // KONIEC ceny

        // START zamówienia
        sendOrder: async (e) => {
            if (defaults.debugMode) {
                console.log('sendOrder()');
            }

            const target = jsKit.getTarget(e);
            if (!target) return;

            const optionId = target.dataset.jsSendOrder;
            const validation = document.querySelector(`[data-valid="${optionId}"]`);

            // reset komunikatu
            validation.innerHTML = '';

            const form = document.querySelector('#formorder');
            if (!form) {
                validation.textContent = 'Brak formularza zamówienia.';
                return;
            }

            // Walidacja wymaganych pól (dla niezalogowanego)
            let daneOK = true;
            const reqInputs = form.querySelectorAll('input.req');
            for (const input of reqInputs) {
                const v = (input.value || '').trim();
                if (v.length === 0) {
                    const ph = input.getAttribute('placeholder') || input.getAttribute('name') || 'pole';
                    validation.innerHTML = `niekompletne dane: ${ph}`;
                    daneOK = false;
                    break;
                }
            }

            // Jeżeli faktura VAT zaznaczona, a NIP pusty
            if (daneOK) {
                const finalny = document.getElementById('Finalny');
                const nip = document.getElementById('NIP');
                if (finalny && finalny.checked && nip && (nip.value || '').trim().length === 0) {
                    daneOK = false;
                    validation.innerHTML = 'niekompletne dane: NIP';
                }
            }

            if (!daneOK) return;

            // Ustaw pola ukryte na podstawie wybranej opcji dostawy/płatności
            const setHidden = (id, val) => {
                const el = document.getElementById(id);
                if (el) el.setAttribute('value', val == null ? '' : String(val));
            };

            setHidden('Spedycja', target.dataset.spedycja);
            setHidden('Forma', target.dataset.forma);
            setHidden('StatusZ', target.dataset.status);
            setHidden('Koszt', target.dataset.koszt);
            setHidden('ks', ams.textStorageXML('ks'));

            // Zapamiętaj wybraną opcję dla kliknięcia POTWIERDZAM
            const confirmBtn = document.querySelector('#order-confirm');
            if (!confirmBtn) {
                validation.textContent = 'Brak przycisku potwierdzenia.';
                return;
            }

            confirmBtn.dataset.orderOptionId = optionId;

            // Bind click tylko raz
            if (confirmBtn.dataset.sendOrderBound === '1') return;
            confirmBtn.dataset.sendOrderBound = '1';

            confirmBtn.addEventListener('click', async (e) => {
                e.preventDefault();

                const currentOptionId = confirmBtn.dataset.orderOptionId;
                const currentValidation = document.querySelector(`[data-valid="${currentOptionId}"]`);

                // jeżeli ktoś kliknie bez wyboru opcji
                if (!currentOptionId || !currentValidation) {
                    return;
                }

                currentValidation.innerHTML = '';

                // walidacja HTML5 (jeśli dostępna)
                if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
                    form.classList.add('was-validated');
                    currentValidation.innerHTML = 'uzupełnij wymagane pola';
                    return;
                }

                jsKit.showLoader(e);

                // POST formularza
                const formData = new URLSearchParams(new FormData(form)).toString();

                const postCB = async (xml) => {
                    const node = xml && xml.querySelector ? xml.querySelector('confirm') : null;
                    const sukces = Number(node?.getAttribute('sukces') || 0);

                    if (!node || sukces === 0) {
                        currentValidation.textContent = 'zamówienie nie zostało wysłane';
                        jsKit.hideLoader(e);
                        return;
                    }

                    let ks = node.getAttribute('ks') || '';
                    let email = node.getAttribute('email') || '';
                    let pf = node.getAttribute('pf') || '';
                    let wz = node.getAttribute('wz') || '';

                    // zapis nowego koszyka
                    ams.setLocal('ks', ks);

                    // dodatkowy request (legacy)
                    const extra = new URLSearchParams({ email, pf, wz }).toString();
                    console.log('extra', extra)
                    await jsKit.fetchUrl('make.asp?i=4a', () => {
                        jsKit.hideLoader(e);
                        window.location = `make.asp?t=31&iddok=${encodeURIComponent(pf)}`;
                    }, 'text', 'POST', extra);

                };

                await jsKit.fetchUrl('make.asp?i=4', postCB, 'xml', 'POST', formData);
            });

        },
        payWithPayU: async (e) => {
            if (defaults.debugMode) {
                console.log('payWithPayU()');
            }

            const {target} = e;
            target.classList.add('loading');

            const containerId = target.dataset.jsPayWithPayU;
            if (!containerId) return;
            const url = `make.asp?i=33&idt=${containerId}`;
            const container = document.querySelector(`#zap${containerId}`);

            const showResult = (html) => {
                if (html) {
                    container.innerHTML = html;
                    const form = container.querySelector('form');

                    if (!form) {
                        console.error('Brak formularza w odpowiedzi');
                        return;
                    }
                    form.submit();
                }
            };

            await jsKit.fetchUrl(url, showResult);
        },
        toggleOrderDetails: async (e) => {
            if (defaults.debugMode) {
                console.log('toggleOrderDetails()');
            }

            const {target} = e;
            const containerId = target.dataset.jsToggleOrderDetails;
            if (!containerId) return;
            const url = `make.asp?i=31&idt=${containerId}`;
            const container = document.querySelector(`#dok${containerId}`);

            if (container.innerHTML.trim() === '') {

                target.classList.add('loading');

                const showResult = (html) => {
                    if (html) {
                        container.innerHTML = html;
                        new bootstrap.Collapse(`#dok${containerId}`).show()
                        target.classList.remove('loading');
                    }
                };

                await jsKit.fetchUrl(url, showResult);

            } else {
                new bootstrap.Collapse(`#dok${containerId}`).toggle()
            }
        },
        // KONIEC zamówienia

        // START koszyk
        deleteItem: (e) => {
            if (defaults.debugMode) {
                console.log('deleteItem()');
            }

            const {target} = e;
            const isBtn = target.classList.contains('btn');
            if (isBtn) {
                target.classList.add('loading');
            }

            const id = target.dataset.jsDeleteItem;
            ams.deleteStorageXML('ks', id)
            window.location.reload();
        },
        basketCount: (e) => document.querySelector("#koszyk_count").innerText = ams.lenStorageXML('ks'),
        sendItem: async (e) => { //sendKS
            if (defaults.debugMode) {
                console.log('sendItem()');
            }

            const {target} = e;
            jsKit.showLoader(e);

            const eventType = e.type !== 'click' ? jsKit.capitalize(e.type) : '';
            const parts = String(target.dataset[`jsSendItem${eventType}`] || '').split(',').map(s => s.trim());
            const id = parts[0];
            const show = Number(parts[1] || 0);
            const update = Number(parts[2] || 0);

            const url = "make.asp?i=3k";

            var input = document.getElementById('ile' + id);
            if (!input) {
                return;
            }

            // aktualna ilość z inputa
            let amount = Number(input.value.replace(/\s/g, ''));
            if (!Number.isFinite(amount) || amount < 1) {
                amount = 1;
            }

            // przyciski +/- przekazują update = 1 lub -1
            if (update) {
                const upd = Number(update);
                if (Number.isFinite(upd) && upd !== 0) {
                    amount = amount + upd;
                    if (amount < 1) amount = 1;
                    input.value = String(amount);
                }
            }

            const postCB = (xml) => {
                const amount = Number(xml.querySelector('z > t')?.getAttribute('k'));
                if (amount === 0) {
                    ams.deleteStorageXML("ks", id)
                } else {
                    ams.insertStorageXML("ks", id, 50, {k: amount})
                }

                if (show) {
                    window.location.href = "make.asp?t=9";
                } else {
                    jsKit.hideLoader(e);
                    jsKit.showModal(`#modal${id}`, {shownCB: () => document.body.style = '' })
                    ams.basketCount();
                }
            };

            await jsKit.fetchUrl(url, postCB, 'xml', 'POST', {id: id, k: amount});

        },
        // KONIEC koszyk

        // START pojazdy
        saveVehicle: async (e) => {
            if (defaults.debugMode) {
                console.log('saveVehicle()');
            }

            const {target} = e;
            const isBtn = target.classList.contains('btn');
            if (isBtn) {
                target.classList.add('loading');
            }

            const [url, formaId, containerId] = target.dataset.jsSaveVehicle.split(', ');
            const form = document.querySelector(`#${formaId}`);
            const formData = new URLSearchParams(new FormData(form)).toString();
            const postCB = (data) => {
                if (data) {
                    document.querySelector(`#${containerId}`).innerHTML = data;
                } else {
                    location.replace("make.asp?t=38")
                }

                if (isBtn) {
                    target.classList.remove('loading');
                }
            };
            await jsKit.fetchUrl(url, postCB, 'text', 'POST', formData);

        },
        showVehicleHistory: async (e) => { //showHW()
            if (defaults.debugMode) {
                console.log('showVehicleHistory()');
            }

            jsKit.showLoader(e);
            const url = 'make.asp?i=18';

            const postCB = (html) => {
                jsKit.openModal(html);
                jsKit.hideLoader(e);
            }

            await jsKit.fetchUrl(url, postCB, 'text', 'POST', {hw: ams.textStorageXML('hw')});

        },
        deleteVehicleHistory: async (e) => {
            if (defaults.debugMode) {
                console.log('deleteVehicleHistory()');
            }

            const {target} = e;
            const isBtn = target.classList.contains('btn');
            if (isBtn) {
                target.classList.add('loading');
            }

            const id = target.dataset.jsDeleteVehicleHistory;
            ams.deleteStorageXML('hw', id)
            await ams.showVehicleHistory(e);
        },
        // KONIEC pojazdy

        // START localStorage helpers (migrated from mSklepJS5.js)
        getBasePath: () => {
            if (defaults.debugMode) {
                console.log('getBasePath()');
            }
            // zgodne z legacy getBasePath() z mSklepJS5.js
            let pPath = '';
            const baseEl = document.querySelector('head base');
            if (baseEl) {
                const href = baseEl.getAttribute('href') || '';
                const tbl = href.split('/');
                // legacy: tbl[3] + "-" (np. https://domena.pl/xxx/yyy/ -> yyy-)
                if (tbl.length > 3 && tbl[3]) {
                    pPath = `${tbl[3]}-`;
                }
            }
            return pPath;
        },
        setLocal: (key, value) => {
            if (defaults.debugMode) {
                console.log('setLocal()');
            }
            const bp = ams.getBasePath();
            localStorage.setItem(bp + key, value);
        },
        getLocal: (key, defaultValue = '') => {
            if (defaults.debugMode) {
                console.log('getLocal()');
            }
            const bp = ams.getBasePath();
            const ls = localStorage.getItem(bp + key);
            return ls ? ls : (defaultValue || '');
        },
        lenStorageXML: (key) => {
            var ls = ams.getLocal(key);
            if (!ls) {
                return ''
            } else {
                var xmlDoc = (new DOMParser()).parseFromString(ls, "text/xml"), x = xmlDoc.documentElement.childNodes;
                var l = x.length;
                l = l ? l : '';
                return l
            }
        },
        textStorageXML: (key) => ams.getLocal(key, "<z/>"),
        insertStorageXML: (key, id, len = 50, params) => {
            if (defaults.debugMode) {
                console.log('insertStorageXML()');
            }
            const ls = ams.getLocal(key, '<z/>');
            const xmlDoc = (new DOMParser()).parseFromString(ls, 'text/xml');
            const de = xmlDoc.documentElement;
            const x = de.childNodes;
            if (id) {
                const el = xmlDoc.getElementById(id);
                if (el) {
                    de.removeChild(el);
                }

                const newNode = xmlDoc.createElement('t');
                newNode.setAttribute('id', id);

                if (params) {
                    for (const ky in params) {
                        if (Object.prototype.hasOwnProperty.call(params, ky)) {
                            if (ky !== 'id') {
                                newNode.setAttribute(ky, params[ky]);
                            }
                        }
                    }
                }

                de.insertBefore(newNode, x[0] || null);

                for (let i = x.length - 1; i > len - 1; i--) {
                    de.removeChild(x[i]);
                }

                ams.setLocal(key, (new XMLSerializer()).serializeToString(xmlDoc));
            }
        },
        parseInsertStorageXmlAttr: (raw) => {
            if (defaults.debugMode) {
                console.log('parseInsertStorageXmlAttr()');
            }
            const value = (raw || '').trim();
            if (!value) return null;

            // JSON
            if (value.startsWith('{') && value.endsWith('}')) {
                try {
                    const obj = JSON.parse(value);
                    if (!obj || !obj.key || !obj.id) return null;
                    return {
                        key: obj.key,
                        id: obj.id,
                        len: Number.isFinite(+obj.len) ? +obj.len : 50,
                        params: obj.params || undefined,
                    };
                } catch (e) {
                    return null;
                }
            }

            // CSV fallback: key,id,len,paramsJson
            // Uwaga: paramsJson może zawierać przecinki -> zakładamy, że to ostatni segment
            const parts = value.split(',');
            if (parts.length < 2) return null;

            const key = (parts[0] || '').trim();
            const id = (parts[1] || '').trim();
            const lenStr = (parts[2] || '').trim();
            const paramsStr = parts.slice(3).join(',').trim();

            if (!key || !id) return null;

            let params;
            if (paramsStr) {
                try {
                    params = JSON.parse(paramsStr);
                } catch (e) {
                    params = undefined;
                }
            }

            return {
                key,
                id,
                len: Number.isFinite(+lenStr) ? +lenStr : 50,
                params,
            };
        },
        insertStorageXMLFromElement: (el) => {
            if (defaults.debugMode) {
                console.log('insertStorageXMLFromElement()');
            }
            if (!el) return '';
            const raw = el.getAttribute('data-js-insert-storage-xml') || '';
            const parsed = ams.parseInsertStorageXmlAttr(raw);
            if (!parsed) return '';
            return ams.insertStorageXML(parsed.key, parsed.id, parsed.len, parsed.params);
        },
        deleteStorageXML: (key, id) => {
            if (defaults.debugMode) {
                console.log('deleteStorageXML()');
            }

            if (!id || id === '0') {
                ams.setLocal(key, '<z/>');
                return 0;
            }

            let ls = ams.getLocal(key, '');
            if (!ls) {
                ls = '<z/>';
            }

            const xmlDoc = (new DOMParser()).parseFromString(ls, 'text/xml');
            const de = xmlDoc && xmlDoc.documentElement;
            if (!de) {
                // jeśli XML jest uszkodzony, resetujemy do pustego
                ams.setLocal(key, '<z/>');
                return '';
            }

            const x = de.childNodes;
            const el = xmlDoc.getElementById(String(id));
            if (el) {
                de.removeChild(el);
            }

            ams.setLocal(key, (new XMLSerializer()).serializeToString(xmlDoc));

        },
        // END localStorage helpers

        // START lista produktów
        pinAdd: (e) => {
            if (defaults.debugMode) {
                console.log('pinAdd()');
            }

            const { target } = e;
            const id = target.dataset.jsPinAdd;
            ams.insertStorageXML('ch', id, 50);
            ams.pinCount()
        },
        removePin: (e) => {
            if (defaults.debugMode) {
                console.log('removePin()');
            }

            const { target } = e;
            const id = target.dataset.jsRemovePin;
            ams.deleteStorageXML('ch', id);
            window.location.reload()
        },
        pinCount: (e) => document.querySelector("#check_count").innerText = ams.lenStorageXML('ch'),
        dataNext: async (e) => {
            if (defaults.debugMode) {
                console.log('dataNext()');
            }

            jsKit.showLoader(e);

            const { target } = e;
            const [url, formaId, containerId] = target.dataset.jsDataNext.split(', ');
            const form = document.querySelector(`#${formaId}`);
            const formData = new URLSearchParams(new FormData(form)).toString();
            const postCB = (html) => {
                document.querySelector(`#${containerId}`).innerHTML = html;
                jsKit.hideLoader(e);
            };
            await jsKit.fetchUrl(url, html => postCB(html), 'text', 'POST', formData );

        },
        toggleProducts: async (e) => {
            if (defaults.debugMode) {
                console.log('toggleProducts()');
            }

            const { target } = e;
            const [url, formaId, containerId] = target.dataset.jsToggleProducts.split(', ');
            const form = document.querySelector(`#${formaId}`);
            const formData = new URLSearchParams(new FormData(form)).toString();
            const container = document.querySelector(`#${containerId}`);

            if (container.innerHTML.trim() === '') {

                target.classList.add('loading');

                const showResult = (html) => {
                    if (html) {
                        container.innerHTML = html;

                        let layout = ams.getLocal("ly", 0);
                        if (!layout) {
                            layout = 'grid';
                        }
                        ams.setLayout(layout);
                        new bootstrap.Collapse(`#${containerId}`).show();
                        target.classList.remove('loading');
                    }
                };

                await jsKit.fetchUrl(url, showResult, 'text', 'POST', formData );

            } else {
                new bootstrap.Collapse(`#${containerId}`).toggle();
            }
        },
        applyProductListFilters: (e = null) => {
            if (defaults.debugMode) {
                console.log('applyProductListFilters()');
            }

            if (e && e.target && e.target.dataset) {
                const t = e.target;
                const changed =
                    (t.dataset.jsProductFilter ? `producer=${t.dataset.jsProductFilter}` : null) ||
                    (t.dataset.jsLocFilter ? `loc=${t.dataset.jsLocFilter}` : null) ||
                    (t.dataset.jsAmountFilter ? `amount=${t.dataset.jsAmountFilter}` : null);

                if (defaults.debugMode && changed) {
                    console.log('applyProductListFilters: changed ->', changed, 'checked=', t.checked);
                }
            }

            // aktywne filtry producentów
            const selectedProducers = Array.from(
                document.querySelectorAll('[data-js-product-filter]:checked')
            )
                .map((el) => el.dataset.jsProductFilter)
                .filter(Boolean);

            // aktywne filtry położenia
            const selectedLocs = Array.from(
                document.querySelectorAll('[data-js-loc-filter]:checked')
            )
                .map((el) => el.dataset.jsLocFilter)
                .filter(Boolean);

            // aktywny filtr dostępności
            const amountEl = document.querySelector('[data-js-amount-filter]:checked');
            const amount = amountEl?.dataset.jsAmountFilter || '1';

            const products = document.querySelectorAll('.card-product-wrapper');
            if (!products.length) return;

            products.forEach((product) => {
                const prod = product.dataset.prod || '';
                const loc = product.dataset.loc || '';
                const stan = parseInt(product.dataset.stan || '0', 10);

                // PRODUCENT
                // Jeżeli ŻADEN producent nie jest zaznaczony, to nie pokazujemy żadnych produktów.
                const matchProducer =
                    selectedProducers.length > 0 && selectedProducers.includes(prod);

                // POŁOŻENIE (fallback: gdy nic nie zaznaczone)
                // AND: produkt musi pasować do KAŻDEGO aktywnego filtra położenia
                // Fix: jeśli opis zawiera "Oś przednia" to filtr "ty" (tył) ma NIE pasować nawet gdy jest "z tyłu" w opisie
                // (analogicznie: "Oś tylna" eliminuje dopasowanie "prz").
                const locStr = String(loc || '');
                const matchLocToken = (code, rawLoc) => {
                    const s = String(rawLoc || '').toLowerCase();

                    // oś (autorytatywna informacja)
                    const isAxleFront = /o\s*ś\s*przednia/i.test(rawLoc) || /os\s*przednia/i.test(s) || /oś\s*przednia/i.test(s);
                    const isAxleRear = /o\s*ś\s*tylna/i.test(rawLoc) || /os\s*tylna/i.test(s) || /oś\s*tylna/i.test(s);

                    // pozycje i strony
                    const hasBothSides = /\bz\s*obu\s*stron\b/i.test(rawLoc) || /\bobu\s*stron\b/.test(s) || /\bobie\s*strony\b/i.test(rawLoc) || /\bobie\s*strony\b/.test(s);
                    const hasLeft = hasBothSides || /\bz\s*lewej\b|\blewa\b|\blewy\b/i.test(rawLoc) || /\bz\s*lewej\b|\blewa\b|\blewy\b/.test(s);
                    const hasRight = hasBothSides || /\bz\s*prawej\b|\bprawa\b|\bprawy\b/i.test(rawLoc) || /\bz\s*prawej\b|\bprawa\b|\bprawy\b/.test(s);
                    const hasFrontPos = /\bz\s*przodu\b|\bprz[oó]d\b|\bprzodu\b/i.test(rawLoc) || /\bz\s*przodu\b|\bprz[oó]d\b|\bprzodu\b/.test(s);
                    const hasRearPos = /\bz\s*ty[łl]u\b|\bty[łl]\b|\bty[łl]u\b/i.test(rawLoc) || /\bz\s*ty[łl]u\b|\bty[łl]\b|\bty[łl]u\b/.test(s);
                    const c = String(code || '').toLowerCase();

                    // mapowanie skrótów: prz / ty / lew / praw
                    if (c === 'lew') return hasLeft;
                    if (c === 'praw') return hasRight;

                    if (c === 'prz') {
                        // jeśli jest wyraźnie "Oś tylna" to nie traktuj "z przodu" jako przód
                        if (isAxleRear) return false;
                        return isAxleFront || hasFrontPos;
                    }

                    if (c === 'ty') {
                        // jeśli jest wyraźnie "Oś przednia" to nie traktuj "z tyłu" jako tył
                        if (isAxleFront) return false;
                        return isAxleRear || hasRearPos;
                    }

                    // fallback: jeśli przyjdzie inny kod, zachowaj stare zachowanie (includes)
                    return s.includes(c);
                };


                const matchLoc =
                    selectedLocs.length === 0 ||
                    selectedLocs.every((l) => matchLocToken(l, locStr));

                // DOSTĘPNOŚĆ
                let matchAmount = true;
                switch (amount) {
                    case '2':
                        matchAmount = stan === 2;
                        break;
                    case '3':
                        matchAmount = stan === 1;
                        break;
                    case '1':
                    default:
                        matchAmount = true;
                        break;
                }

                const isVisible = matchProducer && matchLoc && matchAmount;
                product.classList.toggle('d-none', !isVisible);
            });
        },
        productFilter: (e) => {
            if (defaults.debugMode) {
                console.log('productFilter()');
            }
            ams.applyProductListFilters(e);
        },
        checkLocFilters: () => {
            if (defaults.debugMode) {
                console.log('checkLocFilters()');
            }

            const locWrapper = document.querySelector('[data-js-check-loc-filters]');
            if (!locWrapper) return;

            const loc = locWrapper.querySelectorAll('[data-js-loc-filter]');
            if (!loc.length) return;

            let allHidden = true;

            loc.forEach(l => {
                const hasProducts =
                    document.querySelectorAll(
                        `.card-product-wrapper[data-loc*='${l.dataset.jsLocFilter}']`
                    ).length > 0;

                const formCheck = l.closest('.form-check');
                if (!formCheck) return;

                formCheck.classList.toggle('d-none', !hasProducts);

                if (hasProducts) {
                    allHidden = false;
                }
            });

            locWrapper.classList.toggle('d-none', allHidden);
        },
        locFilter: (e) => {
            if (defaults.debugMode) {
                console.log('locFilter()');
            }
            ams.applyProductListFilters(e);
        },
        amountFilter: (e) => {
            if (defaults.debugMode) {
                console.log('amountFilter()');
            }
            ams.applyProductListFilters(e);
        },
        productToggle: (e) => {
            if (defaults.debugMode) {
                console.log('productToggle()');
            }
            const { target } = e;
            const checkboxes = document.querySelectorAll('[data-js-product-filter]');

            // ustaw stan wszystkich checkboxów bez wywoływania wielu eventów
            checkboxes.forEach((checkbox) => {
                checkbox.checked = target.checked;
            });

            // przelicz filtry raz, na podstawie aktualnego stanu inputów
            ams.applyProductListFilters(e);
        },
        sortProducts: (e) => {
            if (defaults.debugMode) {
                console.log('sortProducts()');
            }

            const { target } = e;
            const attrName = target.dataset.jsSortProducts; // np. "data-price"

            if (!attrName) return;

            // zapamiętujemy kierunek sortowania na przycisku
            const currentDir = target.dataset.sortDir || 'asc';
            const nextDir = currentDir === 'asc' ? 'desc' : 'asc';
            target.dataset.sortDir = nextDir;

            // reset kierunku na innych przyciskach sortowania
            document
                .querySelectorAll('[data-js-sort-products]')
                .forEach(btn => {
                    if (btn !== target) {
                        delete btn.dataset.sortDir;
                    }
                });

            const lists = document.querySelectorAll('[data-list-to-sort]');

            lists.forEach(list => {
                const items = Array.from(list.children);

                items.sort((a, b) => {
                    const aVal = a.getAttribute(attrName);
                    const bVal = b.getAttribute(attrName);

                    const aNum = parseFloat(aVal);
                    const bNum = parseFloat(bVal);

                    // jeśli wartości liczbowe – sortuj liczbowo
                    if (!isNaN(aNum) && !isNaN(bNum)) {
                        return nextDir === 'asc' ? aNum - bNum : bNum - aNum;
                    }

                    // fallback: sortowanie tekstowe
                    const aStr = (aVal || '').toString().toLowerCase();
                    const bStr = (bVal || '').toString().toLowerCase();

                    if (aStr < bStr) return nextDir === 'asc' ? -1 : 1;
                    if (aStr > bStr) return nextDir === 'asc' ? 1 : -1;
                    return 0;
                });

                // wstawiamy posortowane elementy z powrotem
                items.forEach(item => list.appendChild(item));
            });

            ams.setLocal('sr', attrName)
        },
        changeLayout: (e) => {
            if (defaults.debugMode) {
                console.log('changeLayout()');
            }

            const { target } = e;
            const layout = target.dataset.jsChangeLayout;
            ams.setLayout(layout);
        },
        setLayout: (layout) => {
            if (defaults.debugMode) {
                console.log('setLayout()');
            }
            const productLists = document.querySelectorAll('.product-list');
            if(!productLists) return;

            const btnGrid = document.querySelector('[data-js-change-layout="grid"]');
            const btnList = document.querySelector('[data-js-change-layout="list"]');

            if (layout === 'list') {
                productLists.forEach(pl => pl.setAttribute('data-product-views', 'list'));
                if (btnList) {
                    btnList.checked = true;
                }
                if (btnGrid) {
                    btnGrid.checked = false;
                }
            } else {
                productLists.forEach(pl => pl.removeAttribute('data-product-views'));
                if (btnGrid) {
                    btnGrid.checked = true;
                }
                if (btnList) {
                    btnList.checked = false;
                }
            }

            // zapamiętujemy wybór układu
            ams.setLocal('ly', layout);
        },
        toggleSideMenu: (e) => {
            if (defaults.debugMode) {
                console.log('toggleSideMenu()');
            }
            const elemId = e.target.dataset.jsToggleSideMenu;
            const sideMenu = document.getElementById(elemId);
            if (!sideMenu) {
                return;
            }
            if (sideMenu.classList.contains('shown')) {
                sideMenu.classList.remove('shown');
            } else {
                sideMenu.classList.add('shown');
            }
        },
        // KONIEC lista produktów

        calculateAvailability: (scope = document) => {
            const root = scope && scope.querySelectorAll ? scope : document;
            const isSingleWrapper = root instanceof Element && root.matches('[data-product-details]');
            const productWrappers = isSingleWrapper ? [root] : root.querySelectorAll('[data-product-details]');
            const products = isSingleWrapper ? root.querySelectorAll('[data-availability-list]') : root.querySelectorAll('[data-availability-list]');

            const parseTimeToMinutes = (timeStr) => {
                if (!timeStr) return null;
                const match = String(timeStr).match(/(\d{1,2}):(\d{2})/);
                if (!match) return null;
                return Number(match[1]) * 60 + Number(match[2]);
            };

            const extractRemoteState = (el) => {
                const meter = el.querySelector('meter');
                if (meter) {
                    const rawValue = meter.getAttribute('value') ?? meter.value;
                    const value = parseFloat(String(rawValue || '0').replace(',', '.'));
                    if (!Number.isNaN(value)) return value;
                }

                const strong = el.querySelector('strong span');
                if (strong) {
                    const value = parseFloat(
                        String(strong.textContent || '')
                            .replace(',', '.')
                            .replace(/[^\d.\-]/g, '')
                    );
                    if (!Number.isNaN(value)) return value;
                }

                return 0;
            };

            const extractInfoText = (el) => {
                const candidates = Array.from(el.querySelectorAll('.fs-12.text-gray-500'));
                const text = candidates
                    .map((node) => (node.textContent || '').trim())
                    .find(Boolean);

                return text || String(el.dataset.magazynInfo || '').trim();
            };

            const getTimesFromText = (text) => {
                return String(text || '').match(/\d{1,2}:\d{2}/g) || [];
            };

            const parseAvailabilityFromInfoText = (text, nowMinutes) => {
                const rawText = String(text || '').trim();
                if (!rawText) return null;

                const infoTextLower = rawText.toLowerCase();
                const times = getTimesFromText(rawText);
                const firstTime = times[0] || null;
                const lastTime = times.length ? times[times.length - 1] : null;
                const cutoffMinutes = parseTimeToMinutes(firstTime);
                const deliveryMinutes = parseTimeToMinutes(lastTime);

                if (infoTextLower.includes('jutro')) {
                    return {
                        priority: 2000 + (deliveryMinutes ?? 0),
                        label: lastTime ? `dostępne na jutro po ${lastTime}` : 'dostępne na jutro',
                        badgeText: 'dostępne na jutro',
                        badgeClass: 'bg-info'
                    };
                }

                if (
                    infoTextLower.includes('dziś') ||
                    infoTextLower.includes('dzis') ||
                    infoTextLower.includes('odbioru po') ||
                    infoTextLower.includes('dostawa dziś') ||
                    infoTextLower.includes('bedzie do odbioru po') ||
                    infoTextLower.includes('będzie do odbioru po')
                ) {
                    if (cutoffMinutes != null && nowMinutes > cutoffMinutes) {
                        return null;
                    }

                    return {
                        priority: 1000 + (deliveryMinutes ?? 0),
                        label: lastTime ? `dostępne po ${lastTime}` : 'dostępne dziś',
                        badgeText: lastTime ? `dostępne po ${lastTime}` : 'dostępne dziś',
                        badgeClass: 'bg-info'
                    };
                }

                return null;
            };

            const isRemoteSource = (el) => {
                const source = String(el.dataset.availabilitySource || '').trim();
                const typ = String(el.dataset.magazynTyp || '').trim();
                return source === '3' || typ === '3';
            };

            const buildCandidate = (el, nowMinutes) => {
                const remote = isRemoteSource(el);
                const localState = parseFloat(String(el.dataset.magazynStan || '0').replace(',', '.')) || 0;
                const remoteState = extractRemoteState(el);
                const state = remote ? remoteState : localState;
                const infoText = extractInfoText(el);
                const t11 = parseTimeToMinutes(el.dataset.magazynT11);
                const w11 = parseTimeToMinutes(el.dataset.magazynW11);

                // Bierzemy pod uwagę tylko magazyny z realnym stanem > 0.
                // Sam tekst typu "Towar zamówiony do 14:00 będzie do odbioru po 16:00"
                // nie oznacza fizycznej dostępności na stanie.
                if (state <= 0) {
                    return null;
                }

                if (!remote) {
                    return {
                        el,
                        priority: 0,
                        label: 'dostępne od ręki',
                        badgeText: 'dostępne od ręki',
                        badgeClass: 'bg-success'
                    };
                }

                if (t11 != null && w11 != null) {
                    if (nowMinutes <= t11) {
                        return {
                            el,
                            priority: 1000 + w11,
                            label: `dostępne po ${el.dataset.magazynW11}`,
                            badgeText: `dostępne po ${el.dataset.magazynW11}`,
                            badgeClass: 'bg-info'
                        };
                    }

                    return {
                        el,
                        priority: 2000 + w11,
                        label: 'dostępne na jutro',
                        badgeText: 'dostępne na jutro',
                        badgeClass: 'bg-info'
                    };
                }

                const parsedFromText = parseAvailabilityFromInfoText(infoText, nowMinutes);
                if (!parsedFromText) {
                    return {
                        el,
                        priority: 1500,
                        label: 'dostępne',
                        badgeText: 'dostępne',
                        badgeClass: 'bg-info'
                    };
                }

                return {
                    el,
                    ...parsedFromText
                };
            };

            products.forEach((container) => {
                const productId = container.dataset.productId;
                const productWrapper = container.closest('[data-product-details]');
                if (!productWrapper) return;
                const productCard = productWrapper.closest('[data-stan]');
                const addToCartBtn = productWrapper ? productWrapper.querySelector('[data-btn="add-to-cart"]') : null;
                const qtyInput = productWrapper ? productWrapper.querySelector('[data-qty]') : null;
                const badge = productWrapper
                    ? productWrapper.querySelector(`[data-availability-badge][data-product-id="${productId}"]`)
                    : document.querySelector(`[data-availability-badge][data-product-id="${productId}"]`);
                const summary = productWrapper
                    ? productWrapper.querySelector(`[data-availability-summary][data-product-id="${productId}"]`)
                    : document.querySelector(`[data-availability-summary][data-product-id="${productId}"]`);
                const items = Array.from(container.querySelectorAll('[data-availability-item]'));

                if (!items.length) return;

                const now = new Date();
                const nowMinutes = now.getHours() * 60 + now.getMinutes();

                const candidates = items
                    .map((el) => buildCandidate(el, nowMinutes))
                    .filter(Boolean)
                    .sort((a, b) => a.priority - b.priority);

                const best = candidates[0] || null;

                if (!best) {
                    if (badge) {
                        badge.classList.remove('bg-success', 'bg-info', 'bg-warning');
                        badge.classList.add('badge', 'text-white', 'bg-secondary', 'rounded-pill', 'fs-12');
                        badge.innerText = 'niedostępne';
                    }

                    if (addToCartBtn) {
                        addToCartBtn.classList.add('disabled');
                    }

                    if (qtyInput) {
                        qtyInput.disabled = true;
                        qtyInput.readOnly = true;
                    }

                    if (productCard) {
                        productCard.dataset.stan = '0';
                    }

                    // ukryj wszystkie magazyny (nie pokazujemy zer)
                    items.forEach((el) => {
                        el.style.display = 'none';
                    });

                    // opcjonalnie możesz zostawić jeden wiersz informacyjny
                    // ale na razie chowamy wszystko

                    container.classList.remove('d-none');

                    return;
                }

                if (badge) {
                    badge.classList.remove('bg-success', 'bg-info', 'bg-warning', 'bg-secondary');
                    badge.classList.add('badge', 'text-white', 'rounded-pill', 'fs-12', best.badgeClass);
                    badge.innerText = best.badgeText;
                }

                if (productCard) {
                    productCard.dataset.stan = best.badgeText === 'dostępne od ręki' ? '1' : '2';
                }

                if (addToCartBtn) {
                    addToCartBtn.classList.remove('disabled');
                }

                if (qtyInput) {
                    qtyInput.disabled = false;
                    qtyInput.readOnly = false;
                }

                items.forEach((el) => {
                    el.style.display = el === best.el ? '' : 'none';
                });

                container.classList.remove('d-none');

            });
            productWrappers.forEach((wrapper) => {
                const container = wrapper.querySelector('[data-availability-list]');
                if (!container) return;

                const addToCartBtn = wrapper.querySelector('[data-btn="add-to-cart"]');
                if (!addToCartBtn) return;

                const hasBestVisibleItem = !!container.querySelector('[data-availability-item]:not([style*="display: none"])');

                if (!hasBestVisibleItem) {
                    addToCartBtn.classList.add('disabled');
                } else {
                    addToCartBtn.classList.remove('disabled');
                }
            });
        },
        calculateAvailabilityDeferred: (scope = document) => {
            const root = scope && scope.querySelectorAll ? scope : document;
            const wrappers = (root instanceof Element && root.matches('[data-product-details]'))
                ? [root]
                : Array.from(root.querySelectorAll('[data-product-details]'));

            if (!wrappers.length) {
                ams.calculateAvailability(root);
                return;
            }

            wrappers.forEach((wrapper) => {
                const productLoading = wrapper.querySelector('[data-product-loading]');
                const itemsContainer = wrapper.querySelector('[data-availability-items]');
                const addToCartBtn = wrapper.querySelector('[data-btn="add-to-cart"]');
                const qtyInput = wrapper.querySelector('[data-qty]');
                const availabilityBadge = wrapper.querySelector('[data-availability-badge]');
                const availabilitySummary = wrapper.querySelector('[data-availability-summary]');

                let rerunTimer = null;
                let finalizeTimer = null;
                let safetyTimer = null;
                let observer = null;
                let lastActivityAt = window.performance.now();
                let forceFinalize = false;

                const hasRemoteItems = !!wrapper.querySelector(
                    '[data-availability-item][data-availability-source="3"]'
                );

                let settledInteractive = false;
                const getRemoteItems = () => Array.from(
                    wrapper.querySelectorAll('[data-availability-item][data-availability-source="3"]')
                );

                const hasPendingRemoteAvailability = () => {
                    return getRemoteItems().some((item) => item.dataset.magazynLoaded !== '1');
                };

                const hasPendingRemoteInfo = () => {
                    return getRemoteItems().some((item) => item.querySelector('[insertHtml]'));
                };

                const isRemoteDataSettled = () => {
                    if (!hasRemoteItems) {
                        return true;
                    }

                    return !hasPendingRemoteAvailability() && !hasPendingRemoteInfo();
                };

                const showLoading = () => {
                    if (settledInteractive) return;
                    if (productLoading) {
                        productLoading.classList.add('loading');
                    }
                };

                const hideLoading = () => {
                    if (productLoading) {
                        productLoading.classList.remove('loading');
                    }
                };

                const hideAvailabilityUi = () => {
                    if (availabilityBadge) {
                        availabilityBadge.classList.add('d-none');
                    }
                    if (availabilitySummary) {
                        availabilitySummary.classList.add('d-none');
                    }
                };

                const showAvailabilityUi = () => {
                    if (availabilityBadge) {
                        availabilityBadge.classList.remove('d-none');
                    }
                    if (availabilitySummary) {
                        availabilitySummary.classList.remove('d-none');
                    }
                };

                const hasImmediateMainAvailability = () => {
                    const mainItem = wrapper.querySelector('[data-availability-item][data-availability-source="0"]');
                    if (!mainItem) return false;

                    const rawState = String(mainItem.dataset.magazynStan || '0').replace(',', '.');
                    const state = parseFloat(rawState);

                    return Number.isFinite(state) && state >= 1;
                };

                const markActivity = () => {
                    lastActivityAt = window.performance.now();
                    showLoading();
                    hideAvailabilityUi();

                    if (finalizeTimer) {
                        window.clearTimeout(finalizeTimer);
                        finalizeTimer = null;
                    }
                };

                const scheduleFinalize = (delay = 500) => {
                    if (finalizeTimer) {
                        window.clearTimeout(finalizeTimer);
                    }

                    finalizeTimer = window.setTimeout(() => {
                        const quietFor = window.performance.now() - lastActivityAt;

                        if (quietFor < delay) {
                            scheduleFinalize(delay);
                            return;
                        }

                        if (!forceFinalize && !isRemoteDataSettled()) {
                            scheduleFinalize(delay);
                            return;
                        }

                        settledInteractive = true;
                        showAvailabilityUi();
                        hideLoading();
                        finalizeTimer = null;
                    }, delay);
                };

                const runAvailability = () => {
                    ams.calculateAvailability(wrapper);

                    const btnReady = addToCartBtn
                        ? !addToCartBtn.classList.contains('disabled') && !addToCartBtn.disabled
                        : false;

                    const qtyReady = qtyInput
                        ? !qtyInput.disabled
                        : false;

                    if (btnReady && qtyReady) {
                        settledInteractive = true;
                    }

                    scheduleFinalize(500);
                };

                // start
                markActivity();

                // Jeżeli magazyn główny ma od razu realny stan >= 1,
                // zwycięzca jest już ustalony i nie ma sensu trzymać loadera.
                if (hasImmediateMainAvailability()) {
                    ams.calculateAvailability(wrapper);
                    settledInteractive = true;
                    remoteMutationSeen = true;
                    showAvailabilityUi();
                    hideLoading();
                    wrapper.dataset.availabilityObserverInit = 'done';
                    return;
                }

                // pierwszy przebieg po repaint
                window.requestAnimationFrame(() => {
                    runAvailability();
                });

                // observer tylko raz
                if (wrapper.dataset.availabilityObserverInit !== '1' && wrapper.dataset.availabilityObserverInit !== 'done' && itemsContainer) {
                    wrapper.dataset.availabilityObserverInit = '1';

                    observer = new MutationObserver(() => {
                        if (settledInteractive) {
                            return;
                        }

                        markActivity();

                        if (rerunTimer) {
                            window.clearTimeout(rerunTimer);
                        }

                        rerunTimer = window.setTimeout(() => {
                            runAvailability();
                            rerunTimer = null;
                        }, 120);
                    });

                    observer.observe(itemsContainer, {
                        childList: true,
                        subtree: true,
                        characterData: true,
                        attributes: true,
                        attributeFilter: ['value', 'data-magazyn-loaded', 'insertHtml']
                    });
                }

                // safety fallback:
                // jeśli plugin nigdy nic nie zwróci, nie trzymaj loadera w nieskończoność
                if (safetyTimer) {
                    window.clearTimeout(safetyTimer);
                }

                safetyTimer = window.setTimeout(() => {
                    forceFinalize = true;
                    runAvailability();
                }, 10000);
            });
        },
        imageZoomInit: () => {
            if (jsKit.isMobile() || jsKit.rwdMedia.xs() || jsKit.rwdMedia.sm() || jsKit.rwdMedia.md()) {
                return;
            }

            const swiperPhotos = document.querySelector('#swiper-product-photos');
            if (!swiperPhotos) {
                return;
            }

            new LazyLoad();
            new InnerImageZoom('#swiper-product-photos .liz', {
                zoomScale: 0.8,
                zoomType: 'hover',
                fadeDuration: 250,
                fullscreenOnMobile: false,
                hideCloseButton: true,
                hideHint: true,
            });
        },
        loadCollapse: async (eOrEl, openCollapse = true) => {
            if (defaults.debugMode) {
                console.log('loadCollapse()');
            }

            const target = jsKit.getTarget(eOrEl);

            const data = target.dataset.jsLoadCollapse;
            if (!data) return;

            const [url, nodeId] = data.split(', ').map(v => v.trim());

            const container = document.getElementById(`accordion${nodeId}`);
            if (!container) return;

            if (container.innerHTML.trim() === '') {

                jsKit.showLoader(eOrEl);

                const showResult = (html) => {
                    if (html) {
                        container.innerHTML = html;
                        if (openCollapse) new bootstrap.Collapse(`#collapse${nodeId}`).show()
                        jsKit.hideLoader(eOrEl);
                    }
                };

                await jsKit.fetchUrl(url, showResult);

            } else {
                new bootstrap.Collapse(`#collapse${nodeId}`).toggle()
            }

        },
        listFilter: (e) => {

            if (defaults.debugMode) {
                console.log('listFilter()');
            }

            const inputEl = e.target;
            if (!inputEl) return;

            const listSelector = inputEl.dataset.jsListFilter;
            if (!listSelector) return;

            const listEl = document.querySelector(listSelector);
            if (!listEl) return;

            const phrase = (inputEl.value || '').trim().toUpperCase();

            // wszystkie elementy, po których szukamy
            const items = listEl.querySelectorAll('[data-list-search-item]');

            items.forEach((item) => {
                const value = (item.getAttribute('data-list-search-item') || '').toUpperCase();

                const match = phrase === '' || value.includes(phrase);
                item.closest('[data-list-item]').style.display = match ? '' : 'none';
            });

        },
        initTextFilter: (inputId, listId, itemSelector = '.filter-item', hideSelector = itemSelector) => {
            const inputEl = document.getElementById(inputId);
            const listEl = document.getElementById(listId);

            if (!inputEl || !listEl) {
                return;
            }

            const applyFilter = () => {
                const phrase = (inputEl.value || '').trim().toUpperCase();
                const items = Array.from(listEl.querySelectorAll(itemSelector));

                items.forEach((item) => {
                    const target = hideSelector ? (item.closest(hideSelector) || item) : item;
                    const text = (item.textContent || '').trim().toUpperCase();
                    const match = phrase === '' || text.includes(phrase);

                    target.style.display = match ? '' : 'none';
                });
            };

            if (inputEl.dataset.jsTextFilterInit !== '1') {
                inputEl.addEventListener('input', applyFilter);
                inputEl.addEventListener('change', applyFilter);
                inputEl.dataset.jsTextFilterInit = '1';
            }

            applyFilter();
        },
        focusOnModalShow: (modalSelector, inputSelector) => {
            const modalEl = document.querySelector(modalSelector);
            const focusInput = () => {
                const inputEl = document.querySelector(inputSelector);
                if (inputEl) {
                    inputEl.focus();
                }
            };

            if (!modalEl) {
                focusInput();
                return;
            }

            if (modalEl.classList.contains('show')) {
                focusInput();
                return;
            }

            modalEl.addEventListener('shown.bs.modal', focusInput, { once: true });
        },
        initCarousel: (selector, interval = 5000) => {
            const element = document.querySelector(selector);
            if (!element) {
                return;
            }

            const carousel = bootstrap.Carousel.getOrCreateInstance(element, {
                interval,
                ride: 'carousel',
            });

            carousel.cycle();
        },
        initClickableRows: (selector = '.clickable-row') => {
            document.querySelectorAll(selector).forEach((row) => {
                if (row.dataset.jsClickableRowInit === '1') {
                    return;
                }

                row.addEventListener('click', () => {
                    const href = row.dataset.href;
                    if (href) {
                        window.location.href = href;
                    }
                });

                row.dataset.jsClickableRowInit = '1';
            });
        },
        clearInput: (id) => {
            const inputEl = document.getElementById(id);
            if (!inputEl) {
                return false;
            }

            inputEl.value = '';
            inputEl.focus();
            inputEl.dispatchEvent(new Event('input', { bubbles: true }));
            inputEl.dispatchEvent(new Event('change', { bubbles: true }));

            return false;
        },
        deleteVehicle: async (idsa) => {
            if (!idsa) {
                return;
            }

            await fetch(`make.asp?i=66&idsa=${encodeURIComponent(idsa)}`, {
                method: 'GET',
                credentials: 'same-origin',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            window.location.reload();
        },
        collectProductXml: (scope = document) => {
            const ids = Array.from(
                (scope.querySelectorAll
                    ? scope.querySelectorAll('.product[data-id], [data-product-details][data-id]')
                    : [])
            )
                .map((product) => product.getAttribute('data-id'))
                .filter(Boolean);

            return ids.length ? `<z>${ids.map((id) => `<t id="${id}"/>`).join('')}</z>` : '';
        },
        copyMappedHiddenFields: (scope = document) => {
            getScopedElements(scope, '[data-js-copy-to-id]').forEach((field) => {
                const targetId = field.dataset.jsCopyToId;
                const target = document.getElementById(targetId);

                if (target) {
                    target.value = field.value;
                }
            });

            const finalny = document.getElementById('Finalny');
            if (finalny && getScopedElements(scope, '[data-js-copy-to-id]').length > 0) {
                finalny.value = '0';
            }
        },
        updateCatalogParamsCount: async (source) => {
            const form = source instanceof HTMLFormElement
                ? source
                : source?.closest?.('[data-js-catalog-par]');
            if (!form) {
                return;
            }

            const response = await fetch(form.dataset.jsCatalogParUrl || 'make.asp?i=46', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: new URLSearchParams(new FormData(form)).toString(),
            });

            const html = await response.text();
            const countInfo = document.querySelector(form.dataset.jsCatalogParTarget || '#countInfo');
            if (!countInfo) {
                return;
            }

            countInfo.innerHTML = html;

            const dataId = document.getElementById('data-id');
            if (dataId) {
                countInfo.setAttribute('href', dataId.getAttribute('data-href'));
                countInfo.classList.toggle('disabled', dataId.textContent === '0');
            }
        },
        clearCatalogParams: async (e) => {
            const form = e.delegateTarget?.closest?.('[data-js-catalog-par]');
            if (!form) {
                return;
            }

            form.querySelectorAll('select').forEach((field) => {
                field.value = '';
            });

            await ams.updateCatalogParamsCount(form);
        },
        clearCatalogParamInput: async (e) => {
            const inputId = e.delegateTarget?.dataset?.jsClearCatalogParInput;
            const form = e.delegateTarget?.closest?.('[data-js-catalog-par]');
            if (!inputId || !form) {
                return;
            }

            const input = document.getElementById(inputId);
            if (input) {
                input.value = '';
            }

            await ams.updateCatalogParamsCount(form);
        },
        importStorageXml: (e) => {
            const button = e.delegateTarget || e.target;
            const inputId = button?.dataset?.jsImportStorageInput;
            const storageKey = button?.dataset?.jsImportStorageKey || 'ks';
            const limit = Number(button?.dataset?.jsImportStorageLimit || 50);
            const input = inputId ? document.getElementById(inputId) : null;

            if (!input) {
                return;
            }

            const xml = (new DOMParser()).parseFromString(input.value, 'text/xml');
            Array.from(xml.querySelectorAll('z > t')).forEach((item) => {
                ams.insertStorageXML(storageKey, item.getAttribute('id'), limit, { k: item.getAttribute('k') });
            });

            window.location.reload();
        },
        saveValuation: async (e) => {
            const trigger = e.delegateTarget || e.target;
            const form = document.getElementById(trigger?.dataset?.jsSaveValuation || 'formularzWyceny');
            const komunikat = document.getElementById('komunikat');

            if (!form || !komunikat) {
                return;
            }

            komunikat.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
            document.querySelectorAll('.x-send').forEach((button) => {
                button.disabled = true;
            });

            const response = await fetch('make.asp?i=20a', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: new URLSearchParams(new FormData(form)).toString(),
            });

            komunikat.innerHTML = await response.text();
        },
        initDynamicContent: async (scope = document) => {
            const root = scope && scope.querySelectorAll ? scope : document;

            getScopedElements(root, '[data-js-init-text-filter]').forEach((input) => {
                const [listId, itemSelector = '.filter-item', hideSelector = itemSelector] =
                    (input.dataset.jsInitTextFilter || '').split('|').map((part) => part.trim());
                if (listId) {
                    ams.initTextFilter(input.id, listId, itemSelector, hideSelector);
                }
            });

            getScopedElements(root, '[data-js-init-carousel]').forEach((carousel) => {
                const selector = carousel.id ? `#${carousel.id}` : null;
                if (selector) {
                    ams.initCarousel(selector, Number(carousel.dataset.jsInitCarousel || 5000));
                }
            });

            getScopedElements(root, '[data-js-init-clickable-rows]').forEach((element) => {
                ams.initClickableRows(element.dataset.jsInitClickableRows || '.clickable-row');
            });

            if (getScopedElements(root, '[data-js-refresh-prices]').length > 0) {
                ams.setPrices();
            }

            for (const element of getScopedElements(root, '[data-js-init-extra-products]')) {
                const xmlPayload = ams.collectProductXml(element);
                if (xmlPayload) {
                    await ams.getProductAjax(xmlPayload);
                }
            }

            for (const form of getScopedElements(root, '[data-js-catalog-par]')) {
                if (form.dataset.jsCatalogParInit !== '1') {
                    form.addEventListener('change', (event) => {
                        if (event.target.matches('[data-js-catalog-par-select]')) {
                            ams.updateCatalogParamsCount(form);
                        }
                    });
                    form.dataset.jsCatalogParInit = '1';
                }
                await ams.updateCatalogParamsCount(form);
            }

            ams.copyMappedHiddenFields(root);
        },
        loadList: async (e) => {
            if (defaults.debugMode) {
                console.log('loadList()');
            }

            const [url, readValueFromID] = e.target.dataset.jsLoadList.split(',').map(part => part.trim());
            let urlValue = '';

            const el = document.querySelector(readValueFromID);

            if (el && el.tagName === 'INPUT') {
                if (el.type === 'checkbox') {
                    urlValue = el.checked ? el.dataset.jsCheckedValue : el.dataset.jsUncheckedValue;
                }
                else if (el.type === 'text') {
                    urlValue = encodeURIComponent(el.value);
                }
            }

            const getCB = (html) => {
                document.querySelector('#modele-lista').innerHTML = html;
            };
            await jsKit.fetchUrl(url + urlValue, html => getCB(html));
        }

    };
})();

export default ams;
